export default __webpack_public_path__ + "07f1a9df.jpg";